import Refreshment from '@/views/Refreshment/index.vue'

const RefreshmentRouter = {
  path: '/refreshment',
  name: 'Refreshment',
  component: Refreshment,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default RefreshmentRouter
